// extracted by mini-css-extract-plugin
export default {"icon":"style_icon__YSPf7","menuItem":"style_menuItem__f-ka5"};